import React, { useState } from "react";
import Logo from "../../assets/rxultimate.png";
import LoginImage from "../../assets/3836182.jpg";
import axios from "axios";
import { api_url } from "../../utils/data";
import { toast } from "react-toastify";
import { useAuthenticate } from "../../context/AuthContext";
import { Link, Navigate } from "react-router-dom";
import { RotatingLines } from "react-loader-spinner";
import { FaEye, FaEyeSlash } from "react-icons/fa";

const Login = () => {
  const { user } = useAuthenticate();
  const [showPassword, setShowPassword] = useState(false);
  const [loggingIn, setLogginIn] = useState(false);
  const [loginData, setLoginData] = useState({});

  const handleFormChange = (e) => {
    setLoginData({
      ...loginData,
      [e.target.name]: e.target.value,
    });
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  const loginUser = (e) => {
    e.preventDefault();
    setLogginIn(true);
    const config = {
      headers: {
        "Content-Type": "application/json",
      },
    };
    const body = JSON.stringify(loginData);

    axios
      .post(`${api_url}/authentication/login/`, body, config)
      .then((response) => {
        localStorage.setItem("auth", JSON.stringify(response.data));
        updateAccess(response?.data["access"]);

        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: "Bearer " + response?.data["access"],
          },
        };
        axios
          .get(`${api_url}/accounts/me`, config)
          .then((response) => {
            if (response?.data?.is_superuser) {
              window.location.href = "/super-admin/dashboard";
            } else if (response?.data?.is_pharmacy_admin) {
              window.location.href = "/dashboard";
            } else if (response?.data?.is_employee) {
              window.location.href = "/dashboard";
            } else {
              toast.error("Unauthorized access");
              localStorage.removeItem("auth");
            }
          })
          .catch((error) => {
            console.log(error);
          });
        setLogginIn(false);
      })
      .catch((error) => {
        setLogginIn(false);
        if (error?.response?.data) {
          for (const property in error.response.data) {
            if (property !== "detail") {
              toast.error(`${property}: ${error.response.data[property]}`);
            } else {
              toast.error(`${error.response.data[property]}`);
            }
          }
        }
      });
  };

  const updateAccess = (access_token) => {
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + access_token,
      },
    };
    const body = JSON.stringify(loginData);

    axios
      .put(`${api_url}/accounts/access/`, body, config)
      .then((response) => {})
      .catch((error) => {});
  };

  if (user) {
    if (user?.is_superuser) {
      return <Navigate to="/super-admin/dashboard" />;
    } else {
      return <Navigate to="/dashboard" />;
    }
  } else {
    return (
      <div className="min-h-screen w-full bg-white">
        <div className="flex flex-col md:flex-row h-full min-h-screen">
          {/* Form Section */}
          <div className="w-full md:w-1/2 flex items-center justify-center p-4 md:p-8 lg:p-12">
            <div className="w-full max-w-md">
              <form onSubmit={(e) => loginUser(e)} className="w-full">
                <div className="mb-8">
                  <div className="flex justify-center md:justify-start mb-8">
                    <img
                      src={Logo}
                      alt="rxultimate"
                      className="h-16 md:h-20 w-auto"
                    />
                  </div>
                  <div className="">
                    <h3 className="text-xl md:text-2xl font-semibold text-[#526484] mb-2">
                      Login
                    </h3>
                    <p className="text-[#526484] text-sm">
                      Access the Rxultimate portal using your username and password.
                    </p>
                  </div>
                </div>

                <div className="space-y-5">
                  <div className="flex flex-col">
                    <label
                      className="text-[#344357] font-medium text-sm mb-1.5"
                      htmlFor="username"
                    >
                      Username
                    </label>
                    <input
                      type="text"
                      className="py-3 px-4 text-base rounded-lg border border-[#dbdfea] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                      name="username"
                      id="username"
                      placeholder="Enter your username"
                      onChange={(e) => handleFormChange(e)}
                      aria-label="username"
                      required
                    />
                  </div>

                  <div className="flex flex-col">
                    <div className="flex justify-between items-center mb-1.5">
                      <label
                        className="text-[#344357] font-medium text-sm"
                        htmlFor="password"
                      >
                        Password
                      </label>
                      <Link
                        to="/login/forgot-password"
                        className="text-sm text-[#344357] hover:text-blue-500 transition-colors"
                      >
                        Forgot password?
                      </Link>
                    </div>
                    <div className="relative">
                      <input
                        type={showPassword ? "text" : "password"}
                        className="w-full py-3 px-4 text-base rounded-lg border border-[#dbdfea] focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
                        name="password"
                        id="password"
                        placeholder="Enter your password"
                        onChange={(e) => handleFormChange(e)}
                        aria-label="password"
                        required
                      />
                      <button
                        type="button"
                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                        onClick={togglePasswordVisibility}
                      >
                        {showPassword ? (
                          <FaEyeSlash className="text-lg" />
                        ) : (
                          <FaEye className="text-lg" />
                        )}
                      </button>
                    </div>
                  </div>

                  <div className="pt-3">
                    {loggingIn ? (
                      <div className="flex justify-center items-center py-2">
                        <RotatingLines
                          visible={true}
                          height="48"
                          width="48"
                          strokeColor="blue"
                          strokeWidth="5"
                          animationDuration="0.75"
                          ariaLabel="rotating-lines-loading"
                        />
                      </div>
                    ) : (
                      <button
                        type="submit"
                        className="w-full bg-blue-600 hover:bg-blue-700 text-white font-medium py-3 px-4 rounded-lg transition-colors"
                      >
                        Login
                      </button>
                    )}
                    <p className="mt-3">
                      Don't have an account? <Link to="/sign-up" className="text-blue-600 underline">Sign up</Link> now and enjoy a free 30-day trial.
                    </p>
                    
                  </div>
                </div>
              </form>
            </div>
          </div>

          {/* Image Section - Hidden on small screens */}
          <div className="hidden md:flex md:w-1/2 bg-[#f5f6fa] items-center justify-center">
            <img
              src={LoginImage}
              alt="Login illustration"
              className="w-4/5 max-w-lg object-contain"
            />
          </div>
        </div>
      </div>
    );
  }
};

export default Login;